import { Myaccount } from "@app/features/myaccount/myaccount.interface";
import {
  DatePickerInterval,
  DateStringFormat,
} from "@app/shared/_interfaces/dates";
import { Analytic } from "@app/features/analytics/analytics.interface";
import { Emailvalidator } from "@app/features/emailvalidator/emailvalidator.interface";
import { environment } from "@environments/environment";

export const statusColors: Record<Analytic.StatusName, string> = {
  all: "#48484f",
  queued: "#b5b5be",
  delivered: "#0090c2",
  bounce: "#e8c14f",
  opens: "#005293",
  clicks: "#689f38",
  unsubscribes: "#eb5b87",
  spam: "#c62828",
  drop: "#85858d",
};

export const statusDarkColors: Record<Analytic.StatusName, string> = {
  all: "#000000",
  queued: "#b5b5be",
  delivered: "#0090c2",
  bounce: "#e8c14f",
  opens: "#8AC7F9",
  clicks: "#689f38",
  unsubscribes: "#eb5b87",
  spam: "#c62828",
  drop: "#85858d",
};

export const doughnutChartColor = {
  background: {
    light: "#DADADE",
    dark: "#3d3d3d",
  },
};

export const lineChartColor = {
  ticks: {
    light: "#000000",
    dark: "#FFFFFF",
  },
  grid: {
    light: "rgba(0,0,0,0.1)",
    dark: "rgba(255,255,255,0.4)",
  },
  background: {
    light: "rgba(239,245,245,0.6)",
    dark: "rgba(108,108,114,0.4)",
  },
  tooltip: {
    background: {
      light: "rgba(255, 255, 255, .9)",
      dark: "rgba(0,0,0,0.8)",
    },
    border: {
      light: "rgba(0,0,0,0.4)",
      dark: "rgba(255, 255, 255, .4)",
    },
    title: {
      light: "rgba(0,0,0,1)",
      dark: "rgba(255, 255, 255, 1)",
    },
    label: {
      light: "rgba(0, 0, 0, .8)",
      dark: "rgb(255, 255, 255)",
    },
  },
};

export const statusOrders: Record<Analytic.StatusName, number> = {
  all: 8,
  bounce: 5,
  clicks: 3,
  delivered: 6,
  drop: 0,
  opens: 4,
  queued: 7,
  unsubscribes: 2,
  spam: 1,
};

export const optionsLineChart = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },

  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
};

export const authLocalKey = "ts_authkey";
export const authLocalEmail = "ts_authemail";
export const sidebarMobileLocalItemKey = "ts_sidebarmobile";
export const dashboardIntervalLocalItemKey = "ts_dashboard_interval";
export const chartStatusChecked = "ts_chart_statuses";

export const availableLanguages: Myaccount.DropdownItem[] = [
  {
    id: "de",
    key: "Deutsch",
  },
  {
    id: "en",
    key: "English",
  },
  {
    id: "es",
    key: "Español",
  },
  {
    id: "fr",
    key: "Français",
  },
  {
    id: "it",
    key: "Italiano",
  },
  {
    id: "po",
    key: "Português",
  },
  {
    id: "ru",
    key: "Русский",
  },
  {
    id: "ar",
    key: "عربي",
  } /*,
  {
    id: 'he',
    key: 'Hebrew'
  }*/,
];

export const fallBackLanguage = "en";

export const datePickerIntervals: DatePickerInterval = {
  today: [0, 0],
  yesterday: [1, 1],
  last_sevendays: [0, 6],
  last_30days: [0, 29],
  last_3_months: [-1, -1],
  this_month: [-1, -1],
  last_month: [-1, -1],
  this_year: [-1, -1],
};

export const intervalsDashboard: DatePickerInterval = {
  today: [0, 0],
  last_sevendays: [0, 6],
  last_30days: [0, 29],
  last_3_months: [-1, -1],
};

export const emailValidatorStatusColors: Record<
  Emailvalidator.EmailStatus,
  any
> = {
  valid: {
    backgroundColor: "#00B664",
    border: "#00B664",
    color: "#fff",
  },
  invalid: {
    backgroundColor: "#E8C14F",
    color: "#fff",
    border: "#E8C14F",
  },
  catch_all: {
    backgroundColor: "#00B664",
    border: "#00B664",
    color: "#fff",
  },
  unknown: {
    backgroundColor: "#9A9A9A",
    border: "#9A9A9A",
    color: "#fff",
  },
  spamtrap: {
    backgroundColor: "#C62828",
    border: "#C62828",
    color: "#fff",
  },
  abuse: {
    backgroundColor: "#EB5B87",
    border: "#EB5B87",
    color: "#fff",
  },
  do_not_mail: {
    backgroundColor: "#9A9A9A",
    border: "#9A9A9A",
    color: "#fff",
  },
};

export const defaultAnalyticsDateStringFormat: DateStringFormat = {
  s: "s",
  h: "h",
  m: "m",
};

export const passwordRegexPattern: string = "^(?=.*[A-Z])(?=.*[0-9]).{10,}$";

export const enableRestrictionFreePlans = environment.restrictionFreePlans;

export const loginErrors = [
  "authentication_expired",
  "invalid_authorization_key",
  "wrong_credentials_specified",
  "config_server_error",
];

export const supportTicketsUrl =
  "supporttickets.php?systpl=2clic&prodashboard=1";

export const knowledgebaseUrl = "knowledgebase.php?systpl=2clic&prodashboard=1";

export const upgradeCartUrl = "cart.php?systpl=2clic&prodashboard=1";
export const purchaseCartUrl = "cart.php?kck=true";
export const firstPurchaseCartUrl = "cart.php?a=add&pid=:planid&billingcycle=:billingcycle ";

export const invoiceUrl = "viewinvoice.php?id=:invoiceid&from=ca&systpl=2clic";

export const tawkChats: Record<
  string,
  {
    accountKey: string;
    widgetId: string;
  }
> = {
  en: {
    accountKey: "5b9b8524c9abba57967788e4",
    widgetId: "1gce53sp6",
  },
  it: {
    accountKey: "5b9b8524c9abba57967788e4",
    widgetId: "1gcejosaa",
  },
  de: {
    accountKey: "5b9b8524c9abba57967788e4",
    widgetId: "1gcelhu1t",
  },
  es: {
    accountKey: "5b9b8524c9abba57967788e4",
    widgetId: "1gcelg7fg",
  },
  fr: {
    accountKey: "5b9b8524c9abba57967788e4",
    widgetId: "1gcelo60l",
  },
  pt: {
    accountKey: "5b9b8524c9abba57967788e4",
    widgetId: "1gcelm95r",
  },
  ru: {
    accountKey: "5b9b8524c9abba57967788e4",
    widgetId: "1gcelu6ht",
  },
};

export const turboSMTPApiUrl = "https://www.serversmtp.com/turbo-api/";

export const DNSRecords = {
  SPFFull: "v=spf1 a mx include:spf.turbo-smtp.com ?all",
  SPFPartial: "include:spf.turbo-smtp.com",
  SPFAfter: "v=spf1",
  DKIMDomain: "turbo-smtp._domainkey",
  DKIMValue:
    "k=rsa; p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDT3MWLni6so1q9eQggRYBCLHFjohZkCnYHH8gZNDBm6zRrodRVpWpJQW7x3cWWiuBhS1X0IfBB80l5tqFa+yc+mVgnk8tkUzOHFbPQPp4fi7egTpMtsQW/ZMrxw73SItNvPr72qvJTYZNPxarMx+ULjEWybcfEdXHPY8jslGcpCwIDAQAB",
  DMARCDomain: "_dmarc",
  DMARCValue: "v=DMARC1; p=none;",
};
